import { render, staticRenderFns } from "./main_menu.vue?vue&type=template&id=e28b0a5e&"
import script from "./main_menu.vue?vue&type=script&lang=js&"
export * from "./main_menu.vue?vue&type=script&lang=js&"
import style0 from "./main_menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports